<template>
	<!-- 入库记录查询 -->
	<div class="content_main">
		<div class="content_main_top">
			<a-button type="primary" @click="exp"> 数据导出 </a-button>
		</div>
		<div class="content_main_top">
			<a-select v-model="item_type" allowClear class="a_input_self margin_self" placeholder="物品类型"
				@keyup.enter.native="handleSubmitSerch">
				<a-select-option :value="1"> 固定资产 </a-select-option>
				<a-select-option :value="2"> 流动资产 </a-select-option>
			</a-select>
			<a-select v-model="trans_type" allowClear class="a_input_self margin_self" placeholder="入库类型"
				@keyup.enter.native="handleSubmitSerch">
				<a-select-option :value="index" v-for="(item, index) in types" :key="index"> {{ item }}
				</a-select-option>
			</a-select>
			<a-select show-search allowClear placeholder="公司名称" class="margin_self" v-model="company_id"
				@keyup.enter.native="handleSubmitSerch" style="width: 120px">
				<a-select-option :value="item.deptId" v-for="(item, index) in companyList" :key="index">
					{{ item.title }}
				</a-select-option>
			</a-select>
			<!-- <a-select show-search allowClear placeholder="部门名称" class="margin_self" :disabled="!this.company_id" 
						v-model="dept_id" @keyup.enter.native="query" style="width: 120px">
				<a-select-option :value="item.deptId" v-for="(item, index) in deptList" :key="index">
					{{ item.title }}
				</a-select-option>
			</a-select> -->
			<!-- <a-tree-select allowClear :treeData="deptTree" placeholder="部门名称" class="margin_self"
				@keyup.enter.native="query" v-model="dept_id" :disabled="!company_id" style="width: 170px"
				@change="handledept" treeDefaultExpandAll>
			</a-tree-select> -->
			<a-input type="text" class="a_input_self margin_self" placeholder="物品编号" allowClear v-model="item_sn"
				@keyup.enter.native="handleSubmitSerch" />
			<a-input v-model="name" allowClear class="a_input_self margin_self" placeholder="物品名称"
				@keyup.enter.native="handleSubmitSerch" />

			<!-- <a-select show-search allowClear v-model="dept_id" :disabled="!company_id" placeholder="部门名称" class="margin_self" @keyup.enter.native="handleSubmitSerch"
			 style="width: 170px" @change="handledept">
				<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
					{{ item.dept_name }}
				</a-select-option>
			</a-select> -->
			<a-button type="primary" @click="handleSubmitSerch()" style="margin: 5px"> 搜索 </a-button>
			<a-button type="primary" ghost @click="reset()"> 重置 </a-button>
		</div>
		<div class="content_main_center_scroll" id="content_main_center_scroll" style="height:calc(100% - 100)">
			<a-table :data-source="data" bordered :pagination="pagination" :loading="loading"
				@change="handleTableChange" :scroll="{ y: scroll_y }">
				<a-table-column key="index" title="序号" data-index="index" width="70px">
					<template scope="text, record, index">
						{{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
					</template>
				</a-table-column>
				<a-table-column key="companyName" title="公司名称" ellipsis="true" data-index="companyName" />
				<!-- <a-table-column key="deptName" title="责任部门" ellipsis="true" data-index="deptName" /> -->
				<a-table-column key="itemType" title="物品类型" ellipsis="true" data-index="itemType">
					<template scope="text,record">
						<span>{{ record.itemType == 1 ? '固定资产' : '流动资产' }}</span>
					</template>
				</a-table-column>
				<a-table-column key="itemSn" title="物品编号" ellipsis="true" data-index="itemSn" />
				<a-table-column key="name" title="物品名称" ellipsis="true" data-index="name" />
				<a-table-column key="model" title="规格型号" ellipsis="true" data-index="model" />
				<a-table-column key="spuAmount" title="原有库存" ellipsis="true" data-index="spuAmount" />
				<a-table-column key="amount" title="入库数量" ellipsis="true" data-index="amount" />
				<a-table-column key="unit" title="单位" ellipsis="true" data-index="unit" />
				<a-table-column key="operator" title="入库人" ellipsis="true" data-index="operator" />
				<a-table-column key="createTime" title="入库时间" ellipsis="true" data-index="createTime" />
				<a-table-column key="transType" ellipsis="true" title="入库类型" data-index="transType">
					<template scope="text,record">
						<span :style="{ color: Wacolors[record.transType] }">{{ types[record.transType] }}</span>
					</template>
				</a-table-column>
				<a-table-column key="action" title="操作" data-index="action" width="100">
					<template scope="text,record">
						<a @click="details(record)">详情</a>
					</template>
				</a-table-column>
			</a-table>
		</div>
		<a-modal title="入库记录-详情" :visible="visible" @ok="visible = false" @cancel="visible = false" width="880px">
			<template slot="footer">
				<a-button key="back" @click="detailsOk"> 取消 </a-button>
			</template>
			<a-form-model :model="detailsrow" :labelCol="labelCol" :wrapperCol="wrapperCol"
				v-if="detailsrow.itemType == 1">
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="公司名称">
							<span>{{ detailsrow.companyName }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品类型">
							<span>{{ detailsrow.itemType == 1 ? '固定资产' : '流动资产' }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="入库类型">
							<span>{{ detailsrow.transTypeName }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="资产类别">
							<span>{{ detailsrow.assetTypeName }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品编号">
							<span>{{ detailsrow.assetSn }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品名称">
							<span>{{ detailsrow.name }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品状态">
							<span>{{ detailsrow.stateName }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="规格型号">
							<span>{{ detailsrow.model }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="采购时间">
							<span>{{ detailsrow.purchaseTime }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="采购价格">
							<span>{{ detailsrow.purchasePrice }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="责任部门">
							<span>{{ detailsrow.deptName }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="当前估值">
							<span>{{ detailsrow.value }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="责任人">
							<span>{{ detailsrow.charger }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="保管人">
							<span>{{ detailsrow.keeper }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="到货日期">
							<span>{{ detailsrow.arriveTime }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="存放位置">
							<span>{{ detailsrow.storageLoc }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="作业条件">
							<span>{{ detailsrow.storageCond }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="供应商">
							<span>{{ detailsrow.dealer }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="生产厂家">
							<span>{{ detailsrow.manufacturer }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="出厂编号">
							<span>{{ detailsrow.factorySn }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="是否已检定">
							<span>{{ instrumentMap[detailsrow.isInspected]}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="检定周期">
							<span>{{ detailsrow.inspectCycle }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="检定日期">
							<span>{{ detailsrow.inspectTime }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="仪器精度">
							<span>{{ detailsrow.precisions }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="检定结果">
							<span>{{ detailsrow.inspectResult }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="准用说明">
							<span>{{ detailsrow.permit }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="原有库存">
							<span>{{ detailsrow.spuAmount }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="入库数量">
							<span>1</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品单位">
							<span>{{ detailsrow.unit }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="入库人">
							<span>{{ detailsrow.operator }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="入库时间">
							<span>{{ detailsrow.createTime }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="备注信息">
							<span>{{ detailsrow.notes }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="附件信息">
							<div class="view_path" @click="previewFile(item)"
								v-for="(item, index) in detailsrow['attPaths']" :key="index">
								{{ item.name }}
							</div>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品图片">
							<div class="view_path_img" v-for="(item, index) in detailsrow.picPathList" :key="index"
								style="display: flex; justify-content: space-between">
								<div class="view_path_img_margin"></div>
								<div class="view_path_img_center">
									<img :src="item" @click="show_img(index, detailsrow.picPathList)" />
								</div>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>

					<a-col :span="12">
						<a-form-model-item label="证书信息">
							<div class="view_path" @click="previewFile(item)"
								v-for="(item, index) in detailsrow.certPaths" :key="index">
								{{ item.name }}
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
			<a-form-model :model="detailsrow" :labelCol="labelCol" :wrapperCol="wrapperCol"
				v-if="detailsrow.itemType == 2">
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="公司名称">
							<span>{{ detailsrow.companyName }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品类型">
							<span>{{ detailsrow.itemType == 1 ? '固定资产' : '流动资产' }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="入库类型">
							<span>{{ detailsrow.transTypeName }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="资产类别">
							<span>{{ detailsrow.spuTypeName }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品编号">
							<span>{{ detailsrow.spuSn }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品名称">
							<span>{{ detailsrow.name }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="规格型号">
							<span>{{ detailsrow.model }}</span>
						</a-form-model-item>
					</a-col>
					<!-- <a-col :span="12">
						<a-form-model-item label="物品状态">
							<span>{{detailsrow.stateName}}</span>
						</a-form-model-item>
					</a-col> -->

					<a-col :span="12">
						<a-form-model-item label="定值">
							<span>{{ detailsrow.stableLmt }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="生产批号">
							<span>{{ detailsrow.factoryBatch }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="存放位置">
							<span>{{ detailsrow.storageLoc }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="是否已检定">
							<span>{{ instrumentMap[detailsrow.isInspected]}}</span>
						</a-form-model-item>
					</a-col>

					<a-col :span="12">
						<a-form-model-item label="采购均价">
							<span>{{ detailsrow.price }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<!-- <a-row> -->
				<!-- <a-col :span="12">
						<a-form-model-item label="责任部门">
							<span>{{detailsrow.deptName}}</span>
						</a-form-model-item>
					</a-col> -->
				<!-- </a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="使用人(保管人)">
							<span>{{detailsrow.keeper}}</span>
						</a-form-model-item>
					</a-col> -->
				<!-- <a-col :span="12">
						<a-form-model-item label="责任人">
							<span>{{detailsrow.charger}}</span>
						</a-form-model-item>
					</a-col> -->
				<!-- </a-row> -->
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="采购单价">
							<span>{{ detailsrow.purchasePrice }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="供应商">
							<span>{{ detailsrow.dealer }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="生产厂家">
							<span>{{ detailsrow.manufacturer }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="采购时间">
							<span>{{ detailsrow.purchaseTime }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="到货时间">
							<span>{{ detailsrow.arriveTime }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="检定周期">
							<span>{{ detailsrow.inspectCycle }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="检定日期">
							<span>{{ detailsrow.inspectTime }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="检定结果">
							<span>{{ detailsrow.inspectResult }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="原有库存">
							<span>{{ detailsrow.spuAmount }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="入库数量">
							<span>{{ detailsrow.amount }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品单位">
							<span>{{ detailsrow.unit }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="入库人">
							<span>{{ detailsrow.operator }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>

					<a-col :span="12">
						<a-form-model-item label="入库时间">
							<span>{{ detailsrow.createTime }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="备注">
							<span>{{ detailsrow.notes }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="是否为制毒、制爆">
							<span>{{
								detailsrow.hazardType ? detailsrow.hazardType.replace('其他;', '').replace(/;/g, '、')
									: ''
							}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="存放条件">
							<span>{{
								detailsrow.storageCond ? detailsrow.storageCond.replace('其他;', '').replace(/;/g,
									'、') : ''
							}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<preview ref="preview" />
	</div>
</template>

<script>
// import { previewFileLists2} from '@/utils/preview.js'
import { tree_all, enableParent } from '@/api/purchase'
import {
	// transcation_get_list,
	// get_dept_tree,
	get_transcation_xlsx,
	// asset_transcation_get,
	assetTranscation,
	assetDeatil
} from '@/api/assetmenag'
import {
	getDeptListEnable2,
	getDeptListEnable
} from '@/api/system'
import {
	checkPermission
} from '@/utils/permissions'
import {
	ACCESS_TOKEN
} from '@/store/mutation-types'
import preview from '@/components/module/prview'
import storage from 'store'
export default {
	data() {
		return {
			scroll_y: 150,
			companyList: [],
			dataList: [],
			companylist: [],
			deptData: [],
			deptList: [],
			deptlist: [],
			name: '',
			dept_id: undefined,
			company_id: undefined,
			companyMap: {},
			pagination: {
				current: 1,
				pageSize: 10,
				total: 0,
				pageSizeOptions: ['10', '20', '30', '40', '50'],
				showLessItems: true,
				showSizeChanger: true,
			},
			loading: false,
			data: '',
			item_sn: '',
			item_type: undefined,
			trans_type: '127',
			visible: false,
			labelCol: {
				span: 7,
			},
			wrapperCol: {
				span: 17,
			},
			types: {
				'127': '全部类型',
				'1': '直接入库',
				'2': '采购入库',
				'7': '盘盈入库',
			},
			detailsrow: {},
			deptTree: [],
			assetsExportConsumables: checkPermission('assetmenag:consumables:assetsExport'),
		}
	},
	components: {
		preview
	},
	created() {
		enableParent().then(res => {
			var arry = []
			var array1 = {}
			var data = []
			var data1 = {}
			res.rows.forEach(item => {
				if (item.isCompany == 1) {
					console.log(arry, 'arry=======================')
					if (arry.length != 0) {
						arry.forEach(item1 => {
							if (item1.deptId != item.deptId) {
								array1 = {
									deptId: item.deptId,
									title: item.deptName
								}
							}

						})
						arry.push(array1)
					} else {
						array1 = {
							deptId: item.deptId,
							title: item.deptName
						}
						arry.push(array1)
						console.log(arry, 'arry=======================')

					}

				} else if (item.isCompany == 0) {
					if (data.length != 0) {
						data.forEach(item1 => {
							if (item1.deptId != item.deptId) {
								data1 = {
									deptId: item.deptId,
									title: item.deptName,
									parentId: item.parentId
								}
							}

						})
						data.push(data1)
					} else {
						data1 = {
							deptId: item.deptId,
							title: item.deptName,
							parentId: item.parentId
						}
						data.push(data1)
					}
				}
			})
			this.companyList = arry
			this.deptData = data
		})

		// tree_all().then(res => {
		// 	this.dataList = res.data[0]
		// })
		// enableParent().then(res => {
		// 	var array1 = {}
		// 	res.rows.forEach(item => {
		// 		console.log(item, 'item==========================')
		// 		if(item.isCompany == 1) {
		// 			array1 = {
		// 				deptId: item.deptId,
		// 				title: item.deptName
		// 			}
		// 		} 
		// 			this.companyList.push(array1)

		// 	})
		// })
		// get_dept_tree
		// tree_all().then((res) => {
		// 	this.companylist = res.data[0]
		// 	// this.companylist.unshift({
		// 	// 	dept_id: 0,
		// 	// 	dept_name: '所有公司',
		// 	// 	child_lis: [],
		// 	// })
		// 	this.companylist.map((d) => {
		// 		this.companyMap[d.dept_id] = {
		// 			text: d.dept_name,
		// 		}
		// 	})
		// })
	},
	mounted() {
		this.get_list()
		this.$nextTick(() => {
			var max_h = $('#content_main_center_scroll').height()
			setTimeout(() => {
				this.scroll_y = max_h - $('.ant-table-header').height() - 100
			}, 1000)
		})
	},
	methods: {
		// changeDept(e) {
		// 	this.dept_id = ''
		// 	this.deptList = []
		// 		 this.deptData.forEach(item => {
		// 			 if(item.parentId == e) {
		// 				 this.deptList.push(item)
		// 			 }
		// 		 })
		// },
		// changeDept() {
		// 	this.dept_id = ''
		// 	this.dataList.forEach(item => {
		// 		if(item.deptId == e) {
		// 			this.deptTree = item.children
		// 		}
		// 	})

		// },
		reset() {
			this.trans_type = '127'
			this.item_type = undefined
			this.item_sn = ''
			this.name = ''
			this.company_id = undefined
			this.dept_id = undefined
			this.get_list()


		},
		handlecompany(value) {
			this.deptTree = []
			this.deptlist = []
			this.dept_id = undefined
			// this.company_id = this.companylist[value].dept_id
			this.$nextTick(() => {
				getDeptListEnable2().then((res) => {
					const data = res.rows
					if (data.length > 0) {
						const min = Math.min(...data.map((m) => m.parentId))
						this.buildtree2(data, this.deptTree, this.company_id)
					}
				})
			})
			// this.deptlist = this.companylist[value].child_lis
		},
		buildtree2(list, arr, parentId) {
			list.forEach((item) => {
				if (item.parentId === parentId) {
					var child = {
						key: item.deptId,
						value: item.deptId, // value是给modal的select用的，2者属性不一样
						title: item.deptName,
						scopedSlots: {
							title: 'title',
						},
						children: [],
					}
					this.buildtree2(list, child.children, item.deptId)
					if (child.children.length === 0) {
						delete child.children
					}
					arr.push(child)
				}
			})
		},
		detailsOk() {
			this.visible = false
		},
		show_img(idx, imgs) {
			var arr = []
			for (var i = 0; i < imgs.length; i++) {
				arr[i] = {
					preUrl: imgs[i]
				}
			}
			var row = {
				index: idx,
				imgs: arr,
			}

			this.$refs.preview.show(row)
		},
		//预览文件
		previewFile(file) {
			console.log(file)
			window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + file.response.data)
		},
		details(row) {
			// asset_transcation_get
			assetDeatil({
				id: row.id,
				// assetSn: row.assetSn,
			}).then(res => {
				if (res.code == 200) {
					// 	var data = {
					// purchase_price:	res.data.purchasePrice,
					// value: res.data.value,
					// amount: res.data.amount,
					// price: res.data.price,
					// spu_amount: res.data.spuAmount,
					// att_path: res.data.attPath,
					// accuracy_lv: res.data.accuracyLv,
					// arriveTime: res.data.arriveTime,
					// asset_sn: res.data.assetSn,
					// asset_type: res.data.assetType,
					// asset_type_name: res.data.assetTypeName,
					// attPathList: res.data.attPathList,
					// brand: res.data.brand,
					// category_id: res.data.categoryId,
					// certPath: res.data.certPath,
					// cert_path_list: res.data.certPathList,
					// charger: res.data.charger,
					// checkTime: res.data.checkTime,
					// checkin_type: res.data.checkinType,
					// company_id: res.data.companyId,
					// company_name: res.data.companyName,
					// createBy: res.data.createBy,
					// createTime: res.data.createTime,
					// dealer: res.data.dealer,
					// deptId: res.data.deptId,
					// dept_name: res.data.deptName,
					// expire_nime: res.data.expireTime,
					// factory_nn: res.data.factorySn,
					// fixed_value: res.data.fixedValue,
					// id: res.data.id,
					// id_: res.data.id_,
					// inspect_cycle: res.data.inspectCycle,
					// inspect_result: res.data.inspectResult,
					// inspect_time: res.data.inspectTime,
					// is_inspected: res.data.isInspected,
					// is_inspected_name: res.data.isInspectedName,
					// is_instrument: res.data.isInstrument,
					// is_labelled: res.data.isLabelled,
					// is_transfer: res.data.isTransfer,
					// is_virtual: res.data.isVirtual,
					// item_type: res.data.itemType,
					// item_type_name: res.data.itemTypeName,
					// keeper: res.data.keeper,
					// manufacturer: res.data.manufacturer,
					// measure_scope: res.data.measureScope,
					// model: res.data.model,
					// name: res.data.name,
					// next_inspect_time: res.data.nextInspectTime,
					// notes: res.data.notes,
					// operator: res.data.operator,
					// order_id: res.data.orderId,
					// permit: res.data.permit,
					// pic_path: res.data.picPath,
					// pic_path_tist: res.data.picPathList,
					// precisions: res.data.precisions,
					// purchase_amount: res.data.purchaseAmount,
					// purchaseTime: res.data.purchaseTime,
					// purchase_value: res.data.purchaseValue,
					// state: res.data.state,
					// state_name: res.data.stateName,
					// storage_cond: res.data.storageCond,
					// storage_loc: res.data.storageLoc,
					// transType: res.data.transType,
					// transTypeName: res.data.transTypeName,
					// unit: res.data.unit,
					// updateBy: res.data.updateBy,
					// updateTime: res.data.updateTime
					// }

					this.detailsrow = res.data

					// Object.assign(this.detailsrow, {
					// 	itemType: row.itemType

					// })
					// this.detailsrow['purchasePrice'] = this.detailsrow['purchasePrice'] 
					// this.detailsrow['value'] = this.detailsrow['value'] 
					// this.detailsrow['amount'] = this.detailsrow['amount']
					// this.detailsrow['price'] = this.detailsrow['price']
					console.log(this.detailsrow, 'detailsrow=========================')
					this.detailsrow['spuAmount'] = this.detailsrow['spuAmount'] == null ? null : this.detailsrow[
						'spuAmount']
					var att_paths = []
					var cert_paths = []
					console.log(this.detailsrow['attPath'])
					if (this.detailsrow['attPath']) {
						var as = this.detailsrow['attPath'].split(';')
						as.forEach((item) => {
							att_paths.push({
								name: item.split(',')[1],
								response: {
									data: item.split(',')[0],
								},
							})
						})
					}
					if (this.detailsrow['certPath']) {
						var as = this.detailsrow['certPath'].split(';')
						as.forEach((item) => {
							cert_paths.push({
								name: item.split(',')[1],
								response: {
									data: item.split(',')[0],
								},
							})
						})
					}
					this.detailsrow['attPaths'] = att_paths
					this.detailsrow['certPaths'] = cert_paths
					//  previewFileLists2(this.detailsrow.picPathList).then(res=>{
					//             this.detailsrow.picPathList = res
					//    })
					console.log(this.detailsrow.picPathList, 'this.detailsrow.picPathList==========================')
					// var picPathListData = {}
					// this.detailsrow.picPathList.forEach(item => {

					// }
					// )
					// this.detailsrow['picPathList'] = this.detailsrow['picPathList'] ? this.detailsrow['picPathList'].split(
					// 	';') : []

					this.visible = true

				} else {
					this.$message.error(res.msg)
				}

			})

		},
		//搜索
		handleSubmitSerch() {
			this.loading = true
			this.pagination.current = 1
			this.get_list()
		},
		get_list() {
			assetTranscation({
				// transType: 127,
				itemSn: this.item_sn,
				name: this.name,
				transType: this.trans_type,
				itemType: this.item_type,
				companyId: this.company_id,
				deptId: this.dept_id,
				pageIndex: this.pagination.current,
				pageSize: this.pagination.pageSize,
				sortField: 'id',
				sortOrder: 'desc'
			}).then((res) => {
				var lis = res.data.list
				lis.forEach((element) => {
					// element['amount'] = element['amount'] / 100
					element['spu_amount'] = element['spu_amount'] == null ? null : element[
						'spu_amount']
				})
				this.data = lis
				this.loading = false
				const pagination = {
					...this.pagination
				}
				pagination.total = res.data.totalCount
				this.pagination = pagination
			})
			// transcation_get_list({
			// 	trans_type: 127,
			// 	item_sn: this.item_sn,
			// 	name: this.name,
			// 	trans_type:this.trans_type,
			// 	company_id: this.company_id,
			// 	dept_id: this.dept_id,
			// 	page_num: this.pagination.current,
			// 	page_size: this.pagination.pageSize,
			// }).then((res) => {
			// 	var lis = res.data.items
			// 	lis.forEach((element) => {
			// 		element['amount'] = element['amount'] / 100
			// 		element['spu_amount'] = element['spu_amount'] == null ? null : element[
			// 			'spu_amount'] / 100
			// 	})
			// 	this.data = lis
			// 	this.loading = false
			// 	const pagination = {
			// 		...this.pagination
			// 	}
			// 	pagination.total = res.data.total
			// 	this.pagination = pagination
			// })
		},
		//改变分页
		handleTableChange(pagination, filters, sorter) {
			this.pagination.current = pagination.current
			this.pagination.pageSize = pagination.pageSize
			this.loading = true
			this.get_list()
		},
		exp() {
			//  downLoadXlxs2( process.env.VUE_APP_API_BASE_URL + '/daily/consumables/list_excel',{})
			get_transcation_xlsx({
				trans_type: 12,
				item_sn: this.item_sn,
				page_num: 1,
				page_size: 99999,
				excel: 1
			})
			// assetget_list2({
			// 	excel: 1
			// }).then(res => {
			// 	console.log(res)
			// })
		},
	},
}
</script>

<style scoped lang='less'>
.view_path {
	width: 100%;
	float: left;
	cursor: pointer;
}

.ant-form-item {
	margin-bottom: 0 !important;
}
</style>
